import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 13);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="bg-red-600 text-white py-2 px-4 text-center font-bold text-sm md:text-base flex items-center justify-center gap-2" data-id="element-1">
      <span data-id="element-2">
        ⏳ OFERTA EXPIRA EN: {String(minutes).padStart(2, '0')}:
        {String(seconds).padStart(2, '0')} | 🔥 SOLO QUEDAN 3 CUPOS
      </span>
    </div>;
}